import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { GrowingSpacer, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useEffect } from "react";
import styled from "styled-components";
export var LoadingView = function() {
    var reset = useSSOStore().reset;
    useEffect(function() {
        reset();
    }, [
        reset
    ]);
    return /*#__PURE__*/ _jsxs(LoginWrapper, {
        children: [
            /*#__PURE__*/ _jsx(GrowingSpacer, {}),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "duC0Q7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Setting up shop..."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(StyledLoadingSpinner, {}),
            /*#__PURE__*/ _jsx(GrowingSpacer, {})
        ]
    });
};
var StyledLoadingSpinner = styled(LoadingSpinner).withConfig({
    componentId: "sc-61379caf-0"
})([
    "align-self:center;"
]);
